import React from "react";
import { Button, Result } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loading from "components/shared-components/Loading";
import { usePermissions } from "../../data/hooks/usePermissions";
import { getDefaultPath } from "configs/NavigationConfig";

/**
 * Route-guard: toont `children` alleen als de gebruiker de permissie heeft.
 * Het menu verbergt items al, maar een URL intypen kon tot nu toe gewoon —
 * daarom staat deze ook om de routes zelf.
 *
 * Zonder permissie: een 403-pagina met een knop naar de eerste pagina die de
 * gebruiker wél mag zien. Geen automatische redirect, zodat iemand die een
 * oude bookmark gebruikt begrijpt wat er gebeurt.
 */
export const RequirePermission = ({ permission, children }) => {
  const { t } = useTranslation();
  const { can, loading } = usePermissions();

  if (loading) return <Loading cover="content" />;
  if (!permission || can(permission)) return children;

  return (
    <Result
      status="403"
      title={t("no_permission.title")}
      subTitle={t("no_permission.description")}
      extra={
        <Link to={getDefaultPath(can)}>
          <Button type="primary">{t("no_permission.to_home")}</Button>
        </Link>
      }
    />
  );
};

export default RequirePermission;
